<section class="fina-phase-completed">
    <div class="fina-phase-completed__top">
        <span class="fina-phase-completed__spark spark-one">+</span>
        <span class="fina-phase-completed__spark spark-two">+</span>
        <span class="fina-phase-completed__spark spark-three">+</span>

        <div class="fina-phase-completed__trophy">
            <fa-icon [icon]="['fas', 'circle-check']"></fa-icon>
        </div>
    </div>

    <div class="fina-phase-completed__body">
        <div class="fina-phase-completed__eyebrow">{{ phase?.title || 'Fase 2' }} completada</div>
        <h2>¡Felicidades! Tu negocio ya está configurado</h2>
        <p>Completaste todas las tareas. Ahora puedes ver tus números reales en los reportes.</p>

        <div class="fina-phase-completed__metrics">
            <div>
                <strong>{{ completedTaskCount }}/{{ totalTaskCount }}</strong>
                <span>Tareas</span>
            </div>
            <div>
                <strong>{{ mandatoryProgress }}%</strong>
                <span>Obligatorio</span>
            </div>
            <div>
                <strong>{{ overallProgress }}%</strong>
                <span>Total</span>
            </div>
        </div>

        <div class="fina-phase-completed__actions">
            <button type="button" class="secondary" (click)="keepExploring()">Seguir explorando</button>
            <button type="button" class="primary" (click)="goToReports()">Ver mis reportes <fa-icon [icon]="['fas', 'long-arrow-alt-right']"></fa-icon></button>
        </div>
    </div>
</section>
